// Arabic module 10 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enVehicles } from './en-vehicles.ts';
import type { Message } from './types.ts';

export const arVehicles: { readonly [K in keyof typeof enVehicles]: Message } = {
  'api.associationEnded': 'انتهى هذا الارتباط بالفعل.',
  'api.barrierAlreadyRequested': 'طُلب أمر للحاجز لهذا القرار بالفعل. راجع من جديد لطلب آخر.',
  'api.barrierNeedsPermit': 'لا يُرسل أمر الحاجز إلا بعد قرار بالسماح بالدخول.',
  'api.barrierNotConfigured': 'لا يوجد محوّل حاجز مهيأ لهذا الموقع.',
  'api.barrierPermitExpired': 'قرار السماح بالدخول قديم جدًا. راجع الوقائع الحالية من جديد.',
  'api.commandTransition': 'لا يمكن نقل أمر الحاجز من {from} إلى {to}.',
  'api.exceptionResolved': 'استثناء قراءة اللوحة هذا مغلق بالفعل.',
  'api.gateBlocked': 'لا يمكن السماح بالدخول. عالج الموانع المذكورة أو ارفض مع ذكر السبب أو صعّد الطلب.',
  'api.gateEvaluationExpired': 'هذه المراجعة قديمة جدًا للتصرف بناءً عليها. تُعرض الوقائع الحالية — راجعها من جديد.',
  'api.gateUnresolved': 'بعض الوقائع غير معروفة أو قديمة، لذا لا يمكن السماح بالدخول. عالجها أو صعّد الطلب.',
  'api.movementAlreadyVoided': 'صُحّحت هذه الحركة بالفعل.',
  'api.movementNotVoidable': 'لا يمكن تصحيح التصحيح نفسه.',
  'api.noParking': 'لا يوجد تخصيص موقف نشط لهذه المركبة.',
  'api.parkingFull': 'منطقة المواقف هذه ممتلئة خلال نافذة الزيارة. اختر منطقة أخرى.',
  'api.parkingNeedsSchedule': 'يمكن تخصيص الموقف بعد تحديد وقتي بدء الزيارة وانتهائها.',
  'api.parkingSpaceTaken': 'خُصص هذا الموقف لمركبة أخرى للتو. اختر موقفًا آخر.',
  'api.photoIdTaken': 'حُفظت صورة مختلفة لهذا الالتقاط بالفعل. التقط الصورة من جديد.',
  'api.photoNotPermitted': 'لا تسمح سياسة هذا الموقع بالتقاط صورة لهذا الغرض.',
  'api.vehicleAlreadyExpected': 'هذه المركبة متوقعة لهذه الزيارة بالفعل.',
  'api.vehicleAlreadyOnsite': 'هذه المركبة مسجّلة كموجودة في الموقع بالفعل. سجّل خروجها أولًا أو صحّح الدخول السابق.',
  'api.vehicleNotOnsite': 'هذه المركبة مسجّلة كمغادِرة بالفعل.',
  'api.vehicleRemoved': 'لم تعد هذه المركبة متوقعة للزيارة.',
  'api.zoneCapacityBelowAllocations': {
    one: 'يستخدم تخصيص مستقبلي واحد هذه المنطقة. أعد تخصيصه قبل خفض السعة.',
    two: 'يستخدم تخصيصان مستقبليان هذه المنطقة. أعد تخصيصهما قبل خفض السعة.',
    few: 'تستخدم {count} تخصيصات مستقبلية هذه المنطقة. أعد تخصيصها قبل خفض السعة.',
    many: 'يستخدم {count} تخصيصًا مستقبليًا هذه المنطقة. أعد تخصيصها قبل خفض السعة.',
    other: 'يستخدم {count} تخصيص مستقبلي هذه المنطقة. أعد تخصيصها قبل خفض السعة.',
  },
  'v.accessibleOverCapacity': 'لا يمكن أن تتجاوز المواقف المهيأة لذوي الإعاقة سعة المنطقة.',
  'v.candidateUnknown': 'اختر أحد المرشحين المذكورين أو أدخل اللوحة المصحّحة.',
  'v.driverUnknown': 'اختر زائرًا من هذه الزيارة.',
  'v.exactSpacesOff': 'يخصص هذا الموقع المواقف على مستوى المنطقة فقط.',
  'v.exitBeforeEntry': 'لا يمكن أن يكون الخروج قبل الدخول المسجّل.',
  'v.jurisdiction': 'استخدم رمز الدولة مع المنطقة اختياريًا (مثل AE-DU)، أو XX.',
  'v.jurisdictionNotAllowed': 'هذه الجهة المُصدِرة ليست ضمن قائمة الموقع.',
  'v.observedTooOld': 'لا يمكن تسجيل ملاحظات أقدم من 24 ساعة هنا.',
  'v.parkingCode': 'استخدم من 1 إلى 20 حرفًا أو رقمًا أو نقطة أو شرطة.',
  'v.parkingCodeTaken': 'هذا الرمز مستخدم بالفعل.',
  'v.photoNotice': 'أكّد أن إشعار الغرض قد قُدّم.',
  'v.photoPurposeRequired': 'اختر غرضًا واحدًا على الأقل للصور.',
  'v.plateCharacters': 'استخدم الحروف والأرقام فقط (تُتجاهل الفواصل).',
  'v.plateTaken': 'هذه اللوحة مسجّلة بالفعل لدى هذه الجهة المُصدِرة في هذا الموقع.',
  'v.plateTooLong': 'تتكون اللوحة من 12 حرفًا ورقمًا كحد أقصى.',
  'v.procedureTextRequired': 'صِف الإجراء المعتمد عند انقطاع الاتصال.',
  'v.simulatorNotInProduction': 'لا يمكن استخدام المحاكيات في تثبيت إنتاجي.',
  'v.spaceUnavailable': 'اختر موقفًا نشطًا في هذه المنطقة.',
  'v.statusReasonRequired': 'اذكر السبب.',
  'v.vehicleRequired': 'اختر مركبة أو أدخل لوحتها والجهة المُصدِرة.',
  'v.zoneUnavailable': 'اختر منطقة نشطة في هذا الموقع.',
  'specialist.barrier-operator': 'مشغّل الحاجز',
  'specialist.security-supervisor': 'مشرف الأمن',

  'veh.title': 'المركبات ومراجعة البوابة',
  'veh.intro': 'تطابق اللوحة يحدد مرشحًا فقط. ولا يفتح البوابة أبدًا.',
  'veh.notEntitled': 'ميزات المركبات والمواقف واللوحات غير مفعّلة لهذه المؤسسة. تبقى مراجعة الأشخاص عند البوابة متاحة.',
  'veh.tab.queue': 'طابور البوابة',
  'veh.tab.parking': 'المواقف',
  'veh.tab.offline': 'إجراء انقطاع الاتصال',
  'veh.tab.registry': 'السجل',
  'veh.tab.settings': 'إعدادات البوابة',
  'veh.register': 'تسجيل مركبة',
  'veh.registerSub': 'تساعد اللوحة المسجّلة في إيجاد المركبة. ولا تمنح الدخول أبدًا.',
  'veh.registerSubmit': 'تسجيل',
  'veh.registry': 'سجل المركبات',
  'veh.registrySub': 'المركبات المعروفة في هذا الموقع. اللوحة نفسها لدى جهتين مُصدِرتين تعني مركبتين.',
  'veh.registrySearch': 'اللوحة',
  'veh.registryNone': 'لا توجد مركبات مسجّلة.',
  'veh.plate': 'اللوحة',
  'veh.plateHint': 'كما هي مكتوبة على اللوحة. تُتجاهل المسافات والشرطات عند المطابقة.',
  'veh.jurisdiction': 'الجهة المُصدِرة',
  'veh.jurisdictionHint': 'الإمارة أو الدولة التي أصدرت اللوحة.',
  'veh.make': 'الصانع',
  'veh.model': 'الطراز',
  'veh.colour': 'اللون',
  'veh.makeModel': 'الصانع / الطراز',
  'veh.owners': 'الأشخاص والشركات المرتبطة',
  'veh.status': 'الحالة',
  'veh.block': 'حظر',
  'veh.unblock': 'رفع الحظر',
  'veh.until': 'حتى {date}',
  'veh.relation.driver': 'سائق',
  'veh.relation.owner': 'مالك',
  'veh.relation.company_vehicle': 'مركبة شركة',
  'veh.relation.other': 'أخرى',
  'veh.driver': 'السائق',
  'veh.driverNone': 'لم يُحدَّد سائق',
  'veh.drivenBy': 'يقودها {name}',
  'veh.noDetails': 'لا توجد تفاصيل للمركبة',
  'veh.parkingRequested': 'يلزم موقف',
  'veh.accessibleParking': 'يلزم موقف مهيأ لذوي الإعاقة',
  'veh.parkingIn': 'الموقف: {zone}',
  'veh.parkingRequestedNone': 'طُلب موقف ولم يُخصَّص بعد',
  'veh.visit.title': 'المركبات',
  'veh.visit.sub': 'المركبات المتوقعة لهذه الزيارة. لا تُطابق اللوحة إلا ضمن أوقات الزيارة نفسها.',
  'veh.visit.add': 'إضافة مركبة',
  'veh.visit.addSubmit': 'إضافة مركبة',
  'veh.visit.remove': 'إزالة',
  'veh.visit.none': 'لا توجد مركبة متوقعة.',
  'veh.visit.note': 'يُسجَّل دخول المركبة وخروجها عند البوابة بشكل منفصل عن تسجيل وصول كل زائر.',
  'vehicle.status.active': 'نشطة',
  'vehicle.status.blocked': 'محظورة',
  'vehicle.status.inactive': 'غير نشطة',
  'vpresence.no_observation': 'لم تُرصد المركبة',
  'vpresence.observed_onsite': 'المركبة في الموقع',
  'vpresence.observed_departed': 'غادرت المركبة',
  'vpresence.unknown_conflicting': 'وجود المركبة غير معروف',

  'park.title': 'مخطط المواقف',
  'park.sub': 'المناطق والأماكن والتخصيصات الحالية. لا يوجد نظام بوابات متصل.',
  'park.none': 'لا توجد مناطق مواقف بعد.',
  'park.zone': 'المنطقة',
  'park.space': 'الموقف',
  'park.spaces': 'المواقف',
  'park.capacity': 'السعة',
  'park.free': 'المتاح الآن',
  'park.freeCount': { zero: 'ممتلئة', one: 'موقف واحد متاح', two: 'موقفان متاحان', few: '{count} مواقف متاحة', many: '{count} موقفًا متاحًا', other: '{count} موقف متاح' },
  'park.taken': 'مشغول',
  'park.gate': 'البوابة',
  'park.code': 'الرمز',
  'park.name': 'الاسم',
  'park.directions': 'الإرشادات',
  'park.directionsHint': 'تظهر للزائر في تصريحه.',
  'park.addZone': 'إضافة منطقة',
  'park.addZoneSub': 'تُفحص السعة عند كل تخصيص، حتى عندما يخصص مكتبان في الوقت نفسه.',
  'park.addSpace': 'إضافة موقف',
  'park.exactOn': 'يمكن تخصيص مواقف محددة.',
  'park.exactOff': 'تُخصص المواقف على مستوى المنطقة.',
  'park.allocations': 'التخصيصات الحالية',
  'park.allocationsSub': 'المركبات التي لها مواقف خلال الساعة القادمة.',
  'park.allocate': 'تخصيص موقف',
  'park.reallocate': 'تغيير التخصيص',
  'park.change': 'تغيير الموقف',
  'park.chooseZone': 'اختر منطقة…',
  'park.zoneOption': '{name} (المتاح: {free})',
  'park.anySpace': 'أي موقف في المنطقة',
  'park.validity': 'الصلاحية',
  'park.assistance': 'المساعدة',
  'park.accessibleAllocated': 'خُصص موقف مهيأ لذوي الإعاقة.',
  'pass.parking.title': 'الموقف',
  'pass.parking.sub': 'موقفك لهذه الزيارة. لا يفتح أي بوابة بحد ذاته.',

  'gate.m.expected': 'المركبات المتوقعة',
  'gate.m.expectedSub': 'المستحقة اليوم',
  'gate.m.onsite': 'المركبات في الموقع',
  'gate.m.onsiteSub': 'مرصودة لا مُستنتجة',
  'gate.m.exceptions': 'استثناءات اللوحات',
  'gate.m.exceptionsSub': 'تحتاج إلى حارس',
  'gate.m.tasks': 'مهام البوابة المفتوحة',
  'gate.m.tasksSub': 'التصعيدات والمتابعات',
  'gate.attention': 'يحتاج إلى انتباه',
  'gate.attentionSub': 'الموانع وقراءات اللوحات غير المحسومة والمهام المفتوحة أولًا.',
  'gate.blockedExpected': 'متوقعة لكنها ممنوعة حاليًا · المضيف {host}',
  'gate.expected': 'المركبات المتوقعة',
  'gate.expectedSub': 'مراجعة يدوية قبل أي حركة مرصودة.',
  'gate.expectedNone': 'لا توجد مركبات متوقعة اليوم.',
  'gate.onsite': 'المركبات في الموقع',
  'gate.onsiteSub': 'يُسجَّل وجود المركبة بشكل منفصل عن تسجيل وصول كل سائق ومغادرته.',
  'gate.onsiteNone': 'لا توجد مركبة مسجّلة في الموقع.',
  'gate.onsiteSince': 'منذ {time}',
  'gate.overstay': 'تجاوزت نافذتها',
  'gate.driverPresence': 'السائق: {state}',
  'gate.reads': 'قراءات اللوحات الأخيرة',
  'gate.readsSub': 'قراءات الكاميرا تحدد المرشحين فقط.',
  'gate.commands': 'أوامر الحاجز',
  'gate.commandsSub': 'نتائج المحوّل. الإقرار لا يثبت عبور أحد.',
  'gate.col.vehicle': 'المركبة',
  'gate.col.driver': 'السائق',
  'gate.col.visit': 'الزيارة المرتبطة',
  'gate.col.presence': 'الوجود',
  'gate.col.action': 'الإجراء',
  'gate.hint.noBlocker': 'لا مانع حتى الآن',
  'gate.hint.blocked': 'ممنوع',
  'gate.review': 'مراجعة البوابة',
  'gate.recordExit': 'تسجيل الخروج',
  'gate.lookup': 'البحث عن مركبة أو زائر',
  'gate.lookupHint': 'اللوحة أو مرجع الزيارة (V-…) أو رمز QR للتصريح',
  'gate.lookupGo': 'بحث',
  'gate.anyJurisdiction': 'أي جهة مُصدِرة',
  'gate.lookupNone': 'لا تطابق أي مركبة أو زائر متوقع.',
  'gate.lookupNotExpected': 'هذه اللوحة مسجّلة لكنها غير متوقعة الآن. اللوحة المسجّلة ليست إذنًا.',
  'gate.lookupDead': 'رابط التصريح هذا لم يعد صالحًا.',
  'gate.nearMatch': 'لوحة مشابهة — تحقق بعناية',

  'gate.reviewSub': 'الحد الأدنى من الوقائع لهذه البوابة. يتحقق الخادم منها مجددًا عند التصرف.',
  'gate.outcome.clear': 'يمكن السماح',
  'gate.outcome.blocked': 'ممنوع',
  'gate.outcome.unresolved': 'غير محسوم — ليس سليمًا',
  'gate.direction': 'الاتجاه',
  'gate.direction.entry': 'دخول',
  'gate.direction.exit': 'خروج',
  'gate.reviewValid': 'المراجعة صالحة لمدة {seconds} ث.',
  'gate.reviewExpired': 'انتهت صلاحية هذه المراجعة. حدّثها قبل التصرف.',
  'gate.refresh': 'تحديث',
  'gate.matchNotPermission': 'التعرف على المركبة لا يعني أبدًا الإذن بالدخول.',
  'gate.staleNoPermit': 'البيانات قديمة أو انقطع الاتصال. لا يمكن السماح بالدخول بناءً على وقائع قديمة.',
  'gate.person': 'الشخص',
  'gate.noVisit': 'لا توجد زيارة مرتبطة',
  'gate.hostedBy': 'المضيف: {host}',
  'gate.window': 'النافذة',
  'gate.destination': 'الوجهة',
  'gate.vehiclePresence': 'وجود المركبة',
  'gate.facts': 'وقائع القرار',
  'gate.factKey.approval': 'الموافقة',
  'gate.factKey.host_confirmation': 'تأكيد المضيف',
  'gate.factKey.window': 'نافذة الزيارة',
  'gate.factKey.identity': 'الهوية',
  'gate.factKey.credential': 'بيانات الاعتماد المنطقية',
  'gate.factKey.permit': 'التصريح',
  'gate.factKey.screening': 'الفحص',
  'gate.factKey.zone': 'المنطقة المطلوبة',
  'gate.factKey.parking': 'الموقف',
  'gate.factKey.plate_read': 'قراءة اللوحة',
  'gate.factKey.vehicle_presence': 'وجود المركبة',
  'gate.factKey.vehicle_status': 'سجل المركبة',
  'gate.factState.ok': 'سليم',
  'gate.factState.blocked': 'ممنوع',
  'gate.factState.unknown': 'غير معروف',
  'gate.factState.info': 'ملاحظة',
  'gate.factState.not_available': 'غير متاح',
  'gate.source.passage': 'Passage',
  'gate.source.anpr': 'كاميرا اللوحات',
  'gate.source.module_pending': 'غير متصل بعد',
  'gate.source.policy': 'سياسة الموقع',
  'gate.fact.window.open': 'النافذة مفتوحة',
  'gate.fact.window.early': 'مبكر ضمن السماحية',
  'gate.fact.window.not_open': 'لم تُفتح النافذة بعد',
  'gate.fact.window.ended': 'انتهت النافذة',
  'gate.fact.hostConfirmed': 'أكّد المضيف',
  'gate.fact.hostNotConfirmed': 'لم يؤكد المضيف',
  'gate.fact.identityVerified': 'الهوية تستوفي متطلب نوع الزائر هذا',
  'gate.fact.identityNotRequired': 'لا يلزم التحقق من الهوية لنوع الزائر هذا',
  'gate.fact.screeningNotApplicable': 'الفحص الأمني لا ينطبق على نوع الزائر هذا',
  'gate.fact.screening.clear': 'الفحص الأمني سليم',
  'gate.fact.screening.review': 'مطلوب مراجعة أمنية — أحِل إلى مشرف الأمن',
  'gate.fact.screening.confirmed': 'إيقاف أمني — لا تسمح بالدخول؛ اتصل بمشرف الأمن',
  'gate.fact.screening.unavailable': 'الفحص الأمني غير متاح — اتبع إجراء الموقع',
  'gate.blocker.identity_required': 'يحتاج نوع الزائر هذا إلى هوية مُتحقَّق منها قبل الدخول.',
  'gate.blocker.security_hold': 'إيقاف أمني: لا تسمح بالدخول. اتصل بمشرف الأمن.',
  'gate.unknown.security_review': 'هناك مراجعة أمنية معلّقة.',
  'gate.unknown.screening_unavailable': 'تعذّر إكمال الفحص الأمني.',
  'gate.warning.screening_unavailable': 'تعذّر إكمال الفحص الأمني؛ يسمح هذا الموقع بالمتابعة بحذر.',
  'gate.fact.identityNotVerified': 'لم يُتحقق من الهوية في Passage (الوحدة غير متصلة)',
  'gate.fact.contractorEligible': 'فحوص المقاول مستوفاة (الشركة وأدلة العامل والتصريح)',
  'gate.fact.contractorNotEligible': 'فحوص المقاول غير مستوفاة — راجع مكتب المقاولين',
  'gate.fact.contractorNotApplicable': 'لا توجد فحوص مقاولين لهذا النوع من الزيارات',
  'gate.blocker.reentry_not_allowed': 'غادر هذا الشخص بالفعل؛ ولا تسمح السياسة بإعادة الدخول بالزيارة نفسها.',
  'gate.blocker.contractor_not_eligible': 'فحوص المقاول غير مستوفاة (الشركة أو الأدلة أو التصريح).',
  'gate.fact.permitNotConnected': 'فحوص التصاريح غير متصلة بعد',
  'gate.fact.screeningNotConfigured': 'الفحص غير مهيأ',
  'gate.fact.zoneOrdinary': 'منطقة عادية',
  'gate.fact.zoneRestricted': 'منطقة مقيدة — اتبع إجراء الموقع',
  'gate.fact.parkingAllocated': 'خُصص موقف',
  'gate.fact.parkingNone': 'لم يُخصص موقف',
  'gate.fact.readStale': 'القراءة أقدم من أن يُعتمد عليها',
  'gate.read.matched': 'تطابق واحد',
  'gate.read.ambiguous': 'ملتبسة',
  'gate.read.no_match': 'غير مسجّلة',
  'gate.read.low_confidence': 'ثقة منخفضة',
  'gate.read.unreadable': 'غير مقروءة',
  'gate.read.duplicate': 'تكرار',
  'gate.read.noText': 'لا يوجد نص مقروء',
  'gate.blocker.no_linked_visit': 'غير متوقع: لا توجد زيارة مرتبطة الآن.',
  'gate.blocker.visit_not_submitted': 'لم تُقدَّم الزيارة.',
  'gate.blocker.visit_cancelled': 'أُلغيت الزيارة.',
  'gate.blocker.visit_ended': 'انتهت الزيارة.',
  'gate.blocker.participant_removed': 'أُزيل الزائر من الزيارة.',
  'gate.blocker.approval_pending': 'الموافقة ما زالت معلقة.',
  'gate.blocker.approval_rejected': 'لم تُعتمد الزيارة.',
  'gate.blocker.host_confirmation_pending': 'لم يؤكد المضيف هذه الزيارة غير المجدولة.',
  'gate.blocker.window_not_open': 'لم تُفتح نافذة الزيارة (اللوحة المتوقعة ليوم آخر لا تأذن بشيء اليوم).',
  'gate.blocker.window_ended': 'انتهت نافذة الزيارة.',
  'gate.blocker.vehicle_blocked': 'هذه المركبة محظورة في السجل.',
  'gate.blocker.vehicle_inactive': 'هذه المركبة غير نشطة في السجل.',
  'gate.blocker.vehicle_already_onsite': 'هذه المركبة مسجّلة كموجودة في الموقع بالفعل.',
  'gate.unknown.plate_match_ambiguous': 'قراءة اللوحة تطابق أكثر من مركبة.',
  'gate.unknown.plate_match_low_confidence': 'ثقة قراءة اللوحة منخفضة.',
  'gate.unknown.plate_unreadable': 'تعذرت قراءة اللوحة.',
  'gate.unknown.plate_read_stale': 'قراءة اللوحة أقدم من أن يُعتمد عليها.',
  'gate.unknown.vehicle_presence_conflicting': 'وجود المركبة متعارض.',
  'gate.warning.early': 'وصول مبكر ضمن سماحية الموقع.',
  'gate.warning.identity_evidence_missing': 'لم يُتحقق من إثبات الهوية في Passage.',
  'gate.warning.restricted_destination': 'الوجهة منطقة مقيدة.',
  'gate.warning.parking_not_allocated': 'لم يُخصص موقف.',
  'gate.warning.exit_without_entry': 'لم يُسجَّل دخول لهذه المركبة.',

  'gate.permit': 'السماح بالدخول',
  'gate.permitted': 'سُجّل قرار السماح بالدخول. سجّل الدخول المرصود عندما تعبر المركبة.',
  'gate.recordEntry': 'تسجيل الدخول المرصود',
  'gate.queueEntry': 'حفظ الدخول المرصود (دون اتصال)',
  'gate.queueExit': 'حفظ الخروج المرصود (دون اتصال)',
  'gate.entryRecorded': 'سُجّل الدخول المرصود.',
  'gate.exitRecorded': 'سُجّل الخروج المرصود.',
  'gate.taskOpened.unpermitted_entry': 'لم يُسجَّل قرار بالسماح بالدخول؛ فُتحت مهمة متابعة.',
  'gate.taskOpened.offline_reconcile': 'سُجّل دون اتصال ودون قرار حالي؛ أُحيل لمراجعة المشرف.',
  'gate.taskOpened.exit_without_entry': 'لم يُسجَّل دخول؛ فُتحت مهمة متابعة.',
  'gate.observedEntry': 'دخول مرصود',
  'gate.observedExit': 'خروج مرصود',
  'gate.deny': 'رفض الدخول',
  'gate.denied': 'سُجّل الرفض. أبلغ الزائر بالرسالة الآمنة والخطوة التالية.',
  'gate.deny.reason': 'السبب المصنّف',
  'gate.deny.next': 'الخطوة التالية المسموح بها',
  'gate.deny.note': 'ملاحظة',
  'gate.deny.noteHint': 'يراها موظفو البوابة. دون تفاصيل الفحص.',
  'gate.deny.restricted': 'ملاحظة مقيدة',
  'gate.deny.restrictedHint': 'يقرؤها مشرفو الأمن فقط.',
  'gate.deny.visitorSafe': 'يرى الزائر رسالة محايدة لا تكشف أبدًا حالة الفحص أو قوائم المراقبة.',
  'gate.deny.submit': 'تسجيل الرفض',
  'gate.reason.not_expected': 'غير متوقع',
  'gate.reason.outside_window': 'خارج نافذة الزيارة',
  'gate.reason.approval_pending': 'الموافقة معلقة',
  'gate.reason.approval_rejected': 'لم تُعتمد',
  'gate.reason.visit_cancelled': 'أُلغيت الزيارة',
  'gate.reason.vehicle_not_registered': 'المركبة غير مسجّلة',
  'gate.reason.vehicle_blocked': 'المركبة محظورة',
  'gate.reason.identity_unverified': 'تعذر التحقق من الهوية',
  'gate.reason.parking_full': 'لا يوجد موقف متاح',
  'gate.reason.host_unavailable': 'المضيف غير متاح',
  'gate.reason.screening_hold': 'تعليق بسبب الفحص',
  'gate.reason.safety': 'السلامة',
  'gate.reason.other': 'أخرى',
  'gate.reason.restricted': 'سبب مقيد',
  'gate.visitorMessage.contact_host': 'يرجى التواصل مع مضيفك.',
  'gate.visitorMessage.outside_window': 'زيارتك غير مجدولة الآن.',
  'gate.visitorMessage.awaiting_approval': 'زيارتك بانتظار الموافقة.',
  'gate.visitorMessage.vehicle_not_registered': 'هذه المركبة غير مسجّلة لزيارتك.',
  'gate.visitorMessage.identity_check': 'نحتاج إلى استكمال التحقق من الهوية.',
  'gate.visitorMessage.parking_full': 'لا تتوفر مواقف حاليًا.',
  'gate.visitorMessage.cannot_proceed': 'لا يمكن متابعة الدخول في الوقت الحالي.',
  'gate.visitorMessageLabel': 'أُبلغ الزائر: {message}',
  'gate.restrictedNoteLabel': 'ملاحظة مقيدة: {note}',
  'gate.next.contact_host': 'التواصل مع المضيف',
  'gate.next.return_later': 'العودة ضمن نافذة الزيارة',
  'gate.next.visit_reception': 'التوجه إلى الاستقبال',
  'gate.next.register_vehicle': 'تسجيل المركبة',
  'gate.next.leave_site': 'مغادرة الموقع',
  'gate.next.supervisor_review': 'مراجعة المشرف',
  'gate.decision.permit': 'سُمح بالدخول',
  'gate.decision.deny': 'رُفض الدخول',
  'gate.escalate': 'التواصل مع المضيف / التصعيد',
  'gate.escalation.hint': 'سبب بقاء الطلب دون حسم.',
  'gate.escalation.notify': 'إرسال إشعار إلى المضيف',
  'gate.escalation.notApproval': 'التصعيد لا يعتمد الزيارة أبدًا؛ تبقى الموافقة لدى المعتمِدين.',
  'gate.escalation.noSubject': 'يحتاج التصعيد إلى زيارة أو زائر مرتبط.',
  'gate.escalation.opened': 'فُتح التصعيد.',
  'gate.escalation.repeated': 'أُضيف إلى التصعيد المفتوح.',
  'gate.task.host_contact': 'التواصل مع المضيف',
  'gate.task.supervisor_escalation': 'تصعيد إلى المشرف',
  'gate.task.unpermitted_entry': 'دخول مرصود دون قرار بالسماح',
  'gate.task.exit_without_entry': 'خروج مرصود دون دخول مسجّل',
  'gate.task.vehicle_overstay': 'مركبة تجاوزت نافذتها',
  'gate.task.vehicle_left_behind': 'غادر السائق والمركبة ما زالت في الموقع',
  'gate.task.barrier_unknown': 'نتيجة الحاجز غير معروفة',
  'gate.task.photo_declined': 'لم تُلتقط صورة — إجراء بديل',
  'gate.task.offline_reconcile': 'ملاحظة دون اتصال تحتاج إلى مطابقة',
  'gate.task.other': 'مهمة بوابة',
  'gate.task.owner': 'بانتظار {name}',
  'gate.task.repeats': { one: 'صُعّد مرة أخرى', two: 'صُعّد مرتين أخريين', few: 'صُعّد {count} مرات أخرى', many: 'صُعّد {count} مرة أخرى', other: 'صُعّد {count} مرة أخرى' },
  'gate.task.resolution': 'الحل',
  'gate.task.resolve': 'حل',
  'gate.taskEvent.opened': 'فُتحت',
  'gate.taskEvent.repeated': 'صُعّدت مجددًا',
  'gate.taskEvent.owner_changed': 'تغيّر المسؤول',
  'gate.taskEvent.resolved': 'حُلّت',
  'gate.history': 'السجل',
  'gate.movement.entry': 'دخول مرصود',
  'gate.movement.exit': 'خروج مرصود',
  'gate.movement.void': 'سحب',
  'gate.movement.voided': 'مسحوبة',
  'gate.movement.correct': 'تصحيح',
  'gate.method.guard_visual': 'رآها الحارس',
  'gate.method.anpr_confirmed': 'كاميرا اللوحات بتأكيد الحارس',
  'gate.method.manual_plate': 'أدخل الحارس اللوحة',
  'gate.method.offline_reconciled': 'سُجّلت دون اتصال',
  'gate.method.correction': 'تصحيح',

  'gate.exception.ambiguous': 'قراءة لوحة ملتبسة',
  'gate.exception.low_confidence': 'قراءة لوحة بثقة منخفضة',
  'gate.exception.unreadable': 'لوحة غير مقروءة',
  'gate.exception.no_match': 'لوحة غير مسجّلة',
  'gate.exception.sub': 'احسم القراءة يدويًا. تبقى القراءة المرصودة دون تغيير.',
  'gate.exception.never': 'القراءة غير المحسومة أو الملتبسة لا تفتح البوابة أبدًا.',
  'gate.exception.observed': 'القراءة المرصودة',
  'gate.exception.confidence': 'الثقة',
  'gate.exception.noConfidence': 'غير مذكورة',
  'gate.exception.candidates': 'المركبات المحتملة (مُقنّعة)',
  'gate.exception.expectedToday': 'متوقعة اليوم',
  'gate.exception.notExpected': 'غير متوقعة اليوم',
  'gate.exception.corrected': 'اللوحة المصحّحة',
  'gate.exception.correctedHint': 'لا تُطابق إلا لوحة مسجّلة تطابقًا تامًا.',
  'gate.exception.match': 'مطابقة',
  'gate.exception.dismiss': 'تجاهل',
  'gate.exception.resolve': 'حسم',

  'gate.register.open': 'تسجيل وصول',
  'gate.register.title': 'تسجيل وصول بمساعدة الحارس',
  'gate.register.sub': 'الحد الأدنى من التفاصيل فقط. تمر الزيارة بالسياسة والموافقة وتأكيد المضيف المعتادة.',
  'gate.register.givenName': 'الاسم الأول',
  'gate.register.familyName': 'اسم العائلة',
  'gate.register.company': 'الشركة',
  'gate.register.phone': 'الهاتف المحمول',
  'gate.register.host': 'المضيف',
  'gate.register.hostHint': 'اكتب 3 أحرف على الأقل من اسم المضيف. عمليات البحث محدودة.',
  'gate.register.findHost': 'البحث عن المضيف',
  'gate.register.noHost': 'لا يطابق أي مضيف في هذا الموقع.',
  'gate.register.category': 'نوع الزيارة',
  'gate.register.purpose': 'الغرض',
  'gate.register.note': 'يُبلَّغ المضيف. ينتظر الزائر حتى تنجح كل الفحوص.',
  'gate.register.submit': 'التسجيل والتواصل مع المضيف',

  'gate.photo.open': 'صورة',
  'gate.photo.notice': 'اشرح سبب التقاط الصورة وأنها تُحفظ لمدة {days} يومًا. لا تلتقط صورة أبدًا دون إبلاغ الشخص.',
  'gate.photo.noticeGiven': 'قدّمتُ إشعار الغرض',
  'gate.photo.purpose': 'الغرض',
  'gate.photo.purpose.vehicle_condition': 'حالة المركبة',
  'gate.photo.purpose.plate_evidence': 'إثبات اللوحة',
  'gate.photo.purpose.visitor_identification': 'التعرف على الزائر',
  'gate.photo.camera': 'الكاميرا',
  'gate.photo.preview': 'معاينة الصورة',
  'gate.photo.save': 'حفظ الصورة',
  'gate.photo.retake': 'إعادة الالتقاط',
  'gate.photo.saved': 'حُفظت الصورة. تُحفظ لمدة {days} يومًا وتُسجَّل كل مشاهدة.',
  'gate.photo.cameraUnavailable': 'الكاميرا غير متاحة',
  'gate.photo.declined': 'رفض الشخص',
  'gate.photo.assisted': 'سُجّل ذلك. اتبع الإجراء البديل للموقع بدلًا من الصورة.',

  'gate.barrier.open': 'الحاجز',
  'gate.barrier.note': 'يرسل طلب فتح واحدًا عبر محوّل البوابة. لا يُرسل تلقائيًا أبدًا؛ وقد تكون النتيجة غير معروفة فيجب التحقق منها حينئذ.',
  'gate.barrier.submit': 'طلب فتح واحد',
  'gate.barrier.command': 'أمر حاجز عند {gate}',
  'gate.command.queued': 'في الانتظار',
  'gate.command.dispatched': 'أُرسل إلى المحوّل',
  'gate.command.acknowledged': 'أقرّ به المحوّل',
  'gate.command.confirmed': 'مؤكد',
  'gate.command.failed': 'فشل',
  'gate.command.unknown': 'النتيجة غير معروفة',
  'gate.command.reconciling': 'قيد التحقق',
  'gate.command.outcome': 'النتيجة بعد التحقق',
  'gate.command.reconcile': 'تسجيل النتيجة بعد التحقق',

  'gate.offline.banner': 'دون اتصال أو بيانات قديمة',
  'gate.offline.age': { zero: 'عمر البيانات أقل من دقيقة.', one: 'عمر البيانات دقيقة واحدة.', two: 'عمر البيانات دقيقتان.', few: 'عمر البيانات {count} دقائق.', many: 'عمر البيانات {count} دقيقة.', other: 'عمر البيانات {count} دقيقة.' },
  'gate.offline.noData': 'لا توجد بيانات حالية.',
  'gate.offline.noProcedure': 'لا يوجد إجراء معتمد عند انقطاع الاتصال لهذا الموقع: تواصل مع مشرفك.',
  'gate.offline.procedureAvailable': 'اتبع الإجراء المعتمد عند انقطاع الاتصال. البيانات القديمة ليست إذنًا حاليًا أبدًا.',
  'gate.offline.title': 'إجراء انقطاع الاتصال',
  'gate.offline.sub': 'ما يجب فعله عند تعذر الوصول إلى Passage.',
  'gate.offline.rule': 'البيانات القديمة أو المخزنة مؤقتًا ليست إذنًا حاليًا أبدًا. قرارات الدخول تحتاج إلى مراجعة حديثة.',
  'gate.offline.connection': 'الاتصال',
  'gate.offline.online': 'متصل',
  'gate.offline.offline': 'غير متصل',
  'gate.offline.dataAge': 'عمر البيانات',
  'gate.offline.procedure': 'الإجراء المعتمد',
  'gate.offline.noProcedureLong': 'لا يوجد لهذا الموقع إجراء معتمد عند انقطاع الاتصال. لا تُدخل أحدًا بناءً على بيانات مخزنة؛ تواصل مع مشرفك.',
  'gate.offline.queue': 'ملاحظات بانتظار المزامنة',
  'gate.offline.queueEmpty': 'لا شيء بالانتظار.',
  'gate.offline.sync': 'مزامنة الآن',
  'gate.offline.queued': 'حُفظت الملاحظة على هذا الجهاز. زامنها عند عودة الاتصال.',
  'gate.offline.notStored': 'تعذر على هذا الجهاز حفظ الملاحظة. سجّلها وفق الإجراء اليدوي المعتمد.',

  'gpol.title': 'إعدادات البوابة',
  'gpol.sub': 'قيم سياسة الموقع. القيم الافتراضية للتطوير وليست قواعد تشغيل معتمدة.',
  'gpol.early': 'سماحية الوصول المبكر (بالدقائق)',
  'gpol.maxAge': 'صلاحية المراجعة (بالثواني)',
  'gpol.maxAgeHint': 'لا يمكن التصرف بناءً على مراجعة أقدم.',
  'gpol.minConfidence': 'أدنى ثقة لقراءة اللوحة (0.5–1)',
  'gpol.minConfidenceHint': 'تُحال القراءات الأدنى إلى حارس.',
  'gpol.grace': 'مهلة تجاوز الوقت (بالدقائق)',
  'gpol.exactSpaces': 'السماح بمواقف محددة',
  'gpol.notify': 'إرسال إشعار إلى الزوار عند تغيّر الموقف',
  'gpol.photo': 'التقاط الصور',
  'gpol.photoEnabled': 'السماح بالتقاط الصور للأغراض أدناه',
  'gpol.retention': 'مدة حفظ الصور (بالأيام)',
  'gpol.offline': 'إجراء انقطاع الاتصال',
  'gpol.offlineApproved': 'يوجد إجراء معتمد لانقطاع الاتصال لهذا الموقع',
  'gpol.procedure': 'الإجراء المعروض للحراس',
  'gpol.dataAge': 'تُعد البيانات قديمة بعد (بالدقائق)',
  'gpol.barrier': 'محوّل الحاجز',
  'gpol.barrierHint': 'لا يوجد تكامل حقيقي مع الحواجز بعد.',
  'gpol.barrier.none': 'لا شيء',
  'gpol.barrier.simulator': 'محاكي (للتطوير فقط)',
  'gpol.jurisdictions': 'الجهات المُصدِرة للوحات',
  'gpol.jurisdictionsHint': 'رموز مفصولة بفواصل، مثل AE-DU, AE-AZ, SA, XX.',
};
